import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '../../../../../types/product.js';
import { getProductTealiumDescription } from '../../../../../utils/get-product-tealium-description.js';

const RxGlassesCTA = ({ action , onClickWhenOrderable , buttonRef , className , handleConversionEvent , bookAppointmentRouteConfig ,  })=>{
    const { getLabel  } = useIntl();
    const { product , activeVariant  } = useProductData();
    const bookAppointmentLink = useLink(bookAppointmentRouteConfig !== null && bookAppointmentRouteConfig !== void 0 ? bookAppointmentRouteConfig : {
        route: 'appointments.book'
    });
    const configuratorTealiumAttributes = {
        'data-element-id': 'Prod_AddLens',
        'data-description': getProductTealiumDescription(product.name, activeVariant.sku)
    };
    const bookAppointmentTealiumProps = {
        'data-element-id': 'Prod_FindInStore'
    };
    return action === 'OPEN_CONFIGURATOR' ? // Open Configurator button
    /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({
        caption: getLabel('products.actions.openConfigurator'),
        "data-t": "btn-open-configurator",
        onClick: onClickWhenOrderable,
        btnRef: buttonRef,
        className: className
    }, configuratorTealiumAttributes)) : // Book Appointment button
    /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({
        caption: getLabel('products.actions.bookAppointment'),
        "data-t": "btn-book-examination",
        href: bookAppointmentLink === null || bookAppointmentLink === void 0 ? void 0 : bookAppointmentLink.href,
        className: className,
        onClick: handleConversionEvent
    }, bookAppointmentTealiumProps));
};

export { RxGlassesCTA };
//# sourceMappingURL=RxGlassesCTA.js.map
